import { useTranslation } from '../../lib/useTranslation';
import { projectLabel, type CostProject } from './costModel';
import type { CaptureProject } from './costCaptureModel';

export interface CaptureProjectLookup {
  projectLookup?: 'loading' | 'ready' | 'unavailable' | 'error';
  projectLookupError?: string;
  onRetryProjects?: () => void;
}
export default function CaptureProjectSelect({ value, projects, onChange, disabled = false, variant = 'desktop',
  projectLookup = 'ready', projectLookupError, onRetryProjects }: CaptureProjectLookup & {
  value: CaptureProject; projects: CostProject[]; onChange: (value: CaptureProject) => void;
  disabled?: boolean; variant?: 'desktop' | 'mobile' | 'reviewed';
}) {
  const t = useTranslation();
  const unavailable = projectLookup !== 'ready';
  return <label className={variant === 'mobile' ? 'lm-cost-field' : variant === 'desktop' ? 'cst-field' : undefined}>
    <span>{t('costs.fields.project')}</span>
    <select className={variant === 'desktop' ? 'cst-input' : undefined} value={value === undefined ? '__choose__' : value || ''}
      disabled={disabled} onChange={(event) => onChange(event.target.value === '__choose__' ? undefined : event.target.value || null)}>
      <option value="__choose__" disabled>{t('costs.scope.chooseAttribution')}</option>
      <option value="">{t('costs.scope.company')}</option>
      {value && !projects.some((project) => project.id === value) && <option value={value}>{t('costs.scope.selectedProject', { project: value })}</option>}
      {projects.map((project) => <option disabled={unavailable} value={project.id} key={project.id}>{projectLabel(project)}</option>)}
    </select>
    <small>{t('costs.fields.projectHint')}</small>
    {projectLookup === 'loading' && <small role="status">{t('common.loading')}</small>}
    {(projectLookup === 'error' || projectLookup === 'unavailable') && <small role="status">
      {projectLookupError || t(projectLookup === 'error' ? 'costs.scope.lookupFailed' : 'costs.scope.lookupUnavailable')}
    </small>}
    {projectLookup === 'error' && onRetryProjects && <button type="button" disabled={disabled} onClick={onRetryProjects}>{t('common.retry')}</button>}
  </label>;
}
